module.exports = __webpack_public_path__ + "img/galeria-plantas-ornamentales3.7d803afb.jpg";